import React from "react";
import { Footer, Menu } from '../components';
import Container from "react-bootstrap/Container";
import style from './Main.module.scss';
import Sidebar from "../components/Sidebar/Sidebar.component";

const MainLayout = (props) => {
  return (
    <div className={`d-md-flex`}>
      <Sidebar />
      <div className={style.content}>
        {
          props.menu && (
            <Container fluid className={`pl-4 pr-4 sticky-top ${style.navbar}`}>
              <Menu logo={props.logo} />
            </Container>
          )
        }
        {props.children}
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;
